/* eslint-disable vue/multi-word-component-names */
import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css'
import '@splidejs/vue-splide/css' 

import { Splide, SplideSlide } from '@splidejs/vue-splide'
import { createPinia } from 'pinia'
import router from './router'

const app = createApp(App)

app.component('Splide', Splide)
app.component('SplideSlide', SplideSlide)

app.use(createPinia())
app.use(router)
app.mount('#app')
